import i18next from 'i18next';

i18next.addResources('es_CL', 'SearchSection', {
  resultsFor: 'Resultados para "{{term}}"',
  noResults: 'Sin resultados',
  tryOther: 'Intenta con otro término o palabra clave.'
});
